import { css, keyframes } from '@emotion/react';

const Animation = keyframes`
  from {
    opacity: 0;
    transform: translateX(160px);
  }
  to {
    opacity: 1;
    transform: translateX(0px);
  }
`;
export const rightEnter = css`
  animation: ${Animation} 0.64s ease forwards;
  will-change: opacity, transform;
`;
